<template>
  <div class="auth-description">
    <h2 class="auth-title">
      {{ $t('Company details') }}
    </h2>
    <span class="text text-grey">
      {{ $t('Set up company name and invite people to your team') }}
    </span>
    <Form :error="error" :error-text="error" class="login-form auth" @submit="finishRegistration">
      <FormInput
        id="company-name"
        v-model="company"
        class="formcell-24"
        required
        :label-text="$t('Company name')"
        :placeholder="$t('Enter company name')"
      />

      <label class="email-textarea-label">{{ $t('Invite people') }}</label>

      <EmailTextarea :emails="emails" :error="emailsError" @update-emails="updateEmails" />
      <div class="error-message auth-email-error">
        <span v-if="emailsError">{{ $t('Invalid email address') }}</span>
      </div>

      <button :disabled="emailsError" type="submit" class="btn-primary w-button w-full">
        <Spinner v-if="loading" size="20" />
        <span>{{ $t('Finish registration') }}</span>
      </button>
    </Form>
  </div>
</template>

<script>
  import EmailTextarea from '@/components/ui/EmailTextarea';
  import FormInput from '@/components/ui/FormInput';
  import Form from '@/components/common/Form';
  import Spinner from 'vue-simple-spinner';
  import request from '@/utils/api/request';
  import { mapActions, mapState } from 'vuex';
  import parseError from '@/utils/formatting/parse-error';

  export default {
    name: 'CompanyDetailsRegister',
    components: {
      EmailTextarea,
      FormInput,
      Form,
      Spinner,
    },
    data() {
      return {
        company: null,
        emails: [],
        loading: false,
        error: null,
      };
    },
    computed: {
      ...mapState('auth', ['registrationInfo', 'password']),
      emailsError() {
        return this.emails.some((email) => !email.valid);
      },
    },
    methods: {
      ...mapActions('auth', ['login']),
      updateEmails(emails) {
        this.emails = emails;
      },
      async finishRegistration() {
        this.loading = true;
        this.error = null;
        try {
          await request.post('/register/finish/', {
            public_tender_link_hash: this.$router?.currentRoute?.query?.tender || null,
            new_team_name: this.company,
            users_email_for_invite_to_team: this.emails.length
              ? this.emails.map((email) => email.email)
              : null,
          });

          if (this.registrationInfo.email && this.password) {
            await this.login({
              email: this.registrationInfo.email,
              password: this.password,
            });

            await this.$router.push({ name: 'projects' });
            location.reload();
          } else {
            await this.$router.push({ name: 'login' });
          }
        } catch (e) {
          this.error = parseError(e);
        }
        this.loading = false;
      },
    },
  };
</script>
